/* this file is automatically generated.  edit at your own peril */
/* copyright 2015 Minted LLC.  All rights reserved */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:template': [],
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, m_template, _) {
var M = m_module.M;

M.Template || (M.Template = {});
M.Template.Cycler || (M.Template.Cycler = {});

M.Template.Cycler.AboutArtistCarousel = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:STORES
   */
__p+='\n\n\n';
 if (aboutArtistPhotos.length > 1) { 
__p+='\n<div class="cyclerLeftWrapper verticalCenter">\n  <img class="sprite cyclerArrowLeft verticalCenter horizCenter instrumentedElement"\n        data-instrumented-eventspec="click"\n        data-action="M.GA.TRACK_EVENT_ACTION.CAROUSEL_PREVIOUS_CLICK"\n        data-labelcallback="STATIC_VALUE_CALLBACK"\n        data-labelvalue="about_artist_portfolio_photos"\n        src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'" />\n</div>\n<div class="cyclerRightWrapper verticalCenter">\n  <img class="sprite cyclerArrowRight verticalCenter horizCenter instrumentedElement"\n        data-instrumented-eventspec="click"\n        data-action="M.GA.TRACK_EVENT_ACTION.CAROUSEL_PREVIOUS_CLICK"\n        data-labelcallback="STATIC_VALUE_CALLBACK"\n        data-labelvalue="about_artist_portfolio_photos"\n        src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'" />\n</div>\n';
 } 
__p+='\n<div class="aboutArtistPagination cyclerControls cyclerControlsInline"></div>\n<div class="aboutArtistCarousel">\n  ';
 _.each(aboutArtistPhotos, function(photoImageUrl) { 
__p+='\n      <div class="aboutArtistPhoto"\n          style="background-image:url('+
((__t=( M.html.htmlAttributeEscape(photoImageUrl) ))==null?'':__t)+
')"></div>\n  ';
 }); 
__p+='\n</div>\n';
}
return __p;
});

M.Template.Cycler.Art = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n<ul id="cyclerControls" class="cyclerControls cyclerControlsInline">\n  ';
 _.each(slides, function(slide, idx) { 
__p+='\n    <li ';
 if (idx == 0) { 
__p+=' class="active" ';
 } 
__p+='>\n      <a>\n        <img data-slide-id="'+
((__t=( idx ))==null?'':__t)+
'"\n          src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'"\n          class="sprite cyclerPagination" />\n      </a>\n    </li>\n  ';
 }); 
__p+='\n</ul>\n<div class="cycler cyclerBannerArt">\n  ';
 _.each(slides, function(slide, idx) { 
__p+='\n    <div class="slide" style="width:'+
((__t=( width ))==null?'':__t)+
'px; height:'+
((__t=( height ))==null?'':__t)+
'px;">\n      <img src="'+
((__t=( slide.get('image') ))==null?'':__t)+
'" />\n      ';
 if (slide.get('caption')) { 
__p+='\n        <div class="box boxOverlay">\n          <h6>'+
((__t=( slide.get('caption') ))==null?'':__t)+
'</h6>\n          <h1>'+
((__t=( slide.get('title') ))==null?'':__t)+
'</h1>\n          <h5>'+
((__t=( slide.get('curator') ))==null?'':__t)+
' of\n            <a href="'+
((__t=( slide.get('curator_link') ))==null?'':__t)+
'">\n              By '+
((__t=( slide.get('curator_link_text') ))==null?'':__t)+
'\n            </a>\n          </h5>\n          <div class="separator"></div>\n          <a class="button buttonPrimary buttonLarge"\n              href="'+
((__t=( slide.get('button_url') ))==null?'':__t)+
'">\n            '+
((__t=( slide.get('button_text') ))==null?'':__t)+
'\n          </a>\n        </div>\n      ';
 } 
__p+='\n    </div>\n  ';
 }); 
__p+='\n</div>';
}
return __p;
});

M.Template.Cycler.ArtistPicksCarousel = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:STORES
   */
__p+='\n\n<div class="artistPicksCyclerLeftWrapper">\n  <img class="sprite cyclerArrowLeft horizCenter instrumentedElement"\n        data-instrumented-eventspec="click"\n        data-action="M.GA.TRACK_EVENT_ACTION.CAROUSEL_PREVIOUS_CLICK"\n        data-labelcallback="STATIC_VALUE_CALLBACK"\n        data-labelvalue="artist_picks"\n        src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'" />\n</div>\n<div class="artistPicksCyclerRightWrapper">\n  <img class="sprite cyclerArrowRight horizCenter instrumentedElement"\n        data-instrumented-eventspec="click"\n        data-action="M.GA.TRACK_EVENT_ACTION.CAROUSEL_NEXT_CLICK"\n        data-labelcallback="STATIC_VALUE_CALLBACK"\n        data-labelvalue="artist_picks"\n        src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'" />\n</div>\n';
}
return __p;
});

M.Template.Cycler.Default = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n';
 if (IE8) { 
__p+='\n  <ul id="cyclerControls" class="cyclerControls cyclerControlsInline">\n    <li>\n      <a>\n        <img data-slide-id="0"\n          src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'"\n          class="sprite cyclerPagination" />\n      </a>\n    </li>\n  </ul>\n  <div class="cycler" style="height: '+
((__t=( (height + 35) ))==null?'':__t)+
'px">\n    <div class="slide" data-slide-idx="0" style="height: '+
((__t=( height ))==null?'':__t)+
'px">\n      <a href="'+
((__t=( slides[0].get('link_url') ))==null?'':__t)+
'">\n        <img src="'+
((__t=( slides[0].get('img_url') ))==null?'':__t)+
'" />\n      </a>\n    </div>\n  </div>\n';
 } else { 
__p+='\n  <ul id="cyclerControls" class="cyclerControls cyclerControlsInline">\n    ';
 _.each(slides, function(slide, idx) { 
__p+='\n      <li ';
 if (idx == 0) { 
__p+=' class="active" ';
 } 
__p+='>\n        <a>\n          <img data-slide-id="'+
((__t=( idx ))==null?'':__t)+
'"\n            src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'"\n            class="sprite cyclerPagination" />\n        </a>\n      </li>\n    ';
 }); 
__p+='\n  </ul>\n  <div class="cycler" style="height: '+
((__t=( (height + 35) ))==null?'':__t)+
'px">\n    ';
 _.each(slides, function(slide, idx) { 
__p+='\n      <div class="slide" data-slide-idx="'+
((__t=( idx ))==null?'':__t)+
'" style="height: '+
((__t=( height ))==null?'':__t)+
'px">\n        <a href="'+
((__t=( slide.get('link_url') ))==null?'':__t)+
'">\n          <img src="'+
((__t=( slide.get('img_url') ))==null?'':__t)+
'" />\n        </a>\n        ';
 if (slide.get('foot')) { 
__p+='\n          <div class="foot">\n            <span class="floatL">designed by &nbsp;</span>\n            <ul class="inline floatL">\n              ';
 _.each(slide.get('foot'), function(designer) { 
__p+='\n                <li>\n                  <a class="brandLink" href="'+
((__t=( designer['url'] ))==null?'':__t)+
'">\n                    '+
((__t=( designer['name'] ))==null?'':__t)+
'\n                  </a>\n                  <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>\n                  <span>'+
((__t=( designer['location'] ))==null?'':__t)+
'</span>\n                </li>\n              ';
 }); 
__p+='\n            </ul>\n          </div>\n        ';
 } 
__p+='\n      </div>\n    ';
 }); 
__p+='\n  </div>\n';
 } 
__p+='\n';
}
return __p;
});

M.Template.Cycler.MarketplaceBanner = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n\n';
 if (mkplBannerSlides.length > 1) { 
__p+='\n<ul class="marketplaceCyclerControls cyclerControls cyclerControlsInline">\n</ul>\n';
 } 
__p+='\n<div class="marketplaceCycler">\n  ';
 _.each(mkplBannerSlides, function(mkplBanner, idx) { 
__p+='\n      <div class="grid_12 bm mkplBanner"\n          style="background-image:url('+
((__t=( M.html.htmlAttributeEscape(mkplBanner.backgroundImageUrl) ))==null?'':__t)+
')">\n        <div class="mkplBannerFooter" style="display:none">\n          <div class="mkplBannerDesigner floatL">\n            <div class="mkplBannerProfileImageContainer">\n              <a href="/search?designerID='+
((__t=( M.html.htmlAttributeEscape(mkplBanner.designerId) ))==null?'':__t)+
'">\n              <img src="'+
((__t=( M.html.htmlAttributeEscape(mkplBanner.designerProfileImage) ))==null?'':__t)+
'"\n                class="mkplBannerProfileImage"/>\n              </a>\n            </div>\n            <div class="mkplBannerDesignerInfo">\n              <div class="mkplBannerSubtext">\n                <a href="/search?designerID='+
((__t=( M.html.htmlAttributeEscape(mkplBanner.designerId) ))==null?'':__t)+
'">\n                  MEET THE ARTIST\n                </a>\n              </div>\n              <div class="mkplBannerDesignerName">\n                <a href="/search?designerID='+
((__t=( M.html.htmlAttributeEscape(mkplBanner.designerId) ))==null?'':__t)+
'">\n                  '+
((__t=( M.html.htmlAttributeEscape(mkplBanner.designerFullName) ))==null?'':__t)+
'\n                  <span>from</span>\n                  '+
((__t=( M.html.htmlAttributeEscape(mkplBanner.designerLocation) ))==null?'':__t)+
'\n                </a>\n              </div>\n              <div class="mkplBannerSubtext">\n                <a href="/search?designerID='+
((__t=( M.html.htmlAttributeEscape(mkplBanner.designerId) ))==null?'':__t)+
'">\n                  SEE '+
((__t=( M.html.htmlAttributeEscape(mkplBanner.designerFirstName) ))==null?'':__t)+
'\'S WORK &gt;\n                </a>\n              </div>\n            </div>\n          </div>\n          <div class="mkplBannerProductsContainer">\n            <ul>\n              <li class="mkplBannerProductBlock tc">\n                <div class="mkplBannerSeeAllItems">\n                  <a href="/search?designerID='+
((__t=( M.html.htmlAttributeEscape(mkplBanner.designerId) ))==null?'':__t)+
'">\n                    <span>SEE ALL</span>\n                    <span class="mkplBannerItemCount tc">\n                    '+
((__t=( M.html.htmlAttributeEscape(mkplBanner.itemCount) ))==null?'':__t)+
'</span>\n                    <span class="mkplBannerItemString">ITEMS</span>\n                  </a>\n                </div>\n              </li>\n              ';
 _.each(mkplBanner.products, function(productInfo, idx) { 
__p+='\n                <li class="mkplBannerProductBlock">\n                  <a href="'+
((__t=( M.html.htmlAttributeEscape(productInfo.pdpUrl) ))==null?'':__t)+
'">\n                    <div class="mkplBannerProductBlockImage"\n                    style="background-image:url('+
((__t=( M.html.htmlAttributeEscape(productInfo.imgUrl) ))==null?'':__t)+
')">\n                    </div>\n                  </a>\n                </li>\n              ';
 }); 
__p+='\n            </ul>\n          </div>\n        </div>\n      </div>\n  ';
 }); 
__p+='\n</div>\n';
}
return __p;
});

M.Template.Cycler.Wedding = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n<ul id="cyclerControls" class="cyclerControls cyclerControlsInline">\n  ';
 _.each(slides, function(slide, idx) { 
__p+='\n    <li ';
 if (idx == 0) { 
__p+=' class="active" ';
 } 
__p+='>\n      <a>\n        <img data-slide-id="'+
((__t=( idx ))==null?'':__t)+
'"\n          src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'"\n          class="sprite cyclerPagination" />\n      </a>\n    </li>\n  ';
 }); 
__p+='\n</ul>\n<div class="cycler cyclerBannerWedding">\n  ';
 _.each(slides, function(slide, idx) { 
__p+='\n    <div class="slide" style="width:'+
((__t=( width ))==null?'':__t)+
'px; height:'+
((__t=( height ))==null?'':__t)+
'px;">\n      <img src="'+
((__t=( slide.get('image') ))==null?'':__t)+
'" />\n      ';
 if (slide.get('button_url')) { 
__p+='\n        <a class="button buttonTertiary buttonLarge"\n            href="'+
((__t=( slide.get('button_url') ))==null?'':__t)+
'">\n          '+
((__t=( slide.get('button_text') ))==null?'':__t)+
'\n        </a>\n      ';
 } 
__p+='\n    </div>\n  ';
 }); 
__p+='\n</div>';
}
return __p;
});

M.Template.Cycler.WeddingWebsites = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n<ul id="cyclerControls" class="cyclerControls cyclerControlsInline">\n  ';
 _.each(slides, function(slide, idx) { 
__p+='\n    <li ';
 if (idx == 0) { 
__p+=' class="active" ';
 } 
__p+='>\n      <a>\n        <img data-slide-id="'+
((__t=( idx ))==null?'':__t)+
'"\n          src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'"\n          class="sprite cyclerPagination" />\n      </a>\n    </li>\n  ';
 }); 
__p+='\n</ul>\n<div class="cycler cyclerWeddingWebsites">\n  ';
 _.each(slides, function(slide, idx) { 
__p+='\n    <div class="slide" style="width:'+
((__t=( width ))==null?'':__t)+
'px; height:'+
((__t=( height ))==null?'':__t)+
'px;">\n      <img src="'+
((__t=( slide.get('image') ))==null?'':__t)+
'" />\n    </div>\n  ';
 }); 
__p+='\n</div>\n';
}
return __p;
});


return {};

});
/* end templito generated file */
